import { EventPriceKind } from '../../../graphql/generatedTypes';

export type EventPriceTarget = { kind: EventPriceKind; id: number };

export type PricedItemType = {
  id: number;
  name?: string | null;
  image_url?: string | null;
  color_hex_code?: string | null;
};

export const priceTarget = (price: {
  kind: EventPriceKind;
  container_type_id?: number | null;
  item_type_id?: number | null;
}): EventPriceTarget => ({
  kind: price.kind,
  id:
    price.kind === EventPriceKind.ContainerType
      ? (price.container_type_id as number)
      : (price.item_type_id as number),
});

export const isSameTarget = (a: EventPriceTarget, b: EventPriceTarget) =>
  a.kind === b.kind && a.id === b.id;
